export const locales = {
    'en': {
        'contacts':'contacts',
        'projects':'projects',
        'home': 'home',
        'about': 'about',
        'under_development': 'under development',
        'houses':'residential',
        'residential':'residential',
        'commercial':'commercial',
        'project': 'project',
        'back_to_featured_projects': 'back to featured projects',
        'back_to_projects': 'back to projects',
        'category':'category',
        'view_project':'view project'
    },
    'bg': {
        'contacts':'контакти',
        'projects':'проекти',
        'home': 'начало',
        'about': 'за нас',
        'under_development': 'в процес на разработка',
        'houses':'жилищни',
        'residential': 'жилищни интериори',
        'commercial':'обществени интериори',
        'project': 'проект',
        'back_to_featured_projects': 'назад към избраните проекти',
        'back_to_projects': 'назад към всички проекти',
        'category':'категория',
        'view_project':'виж проекта'
    }
};